import { Theme } from "@mui/material";

const controlledTextFieldStyles = (theme: Theme) => ({
    labelFilled: {
        fontSize: '1.05rem !important',
        marginBottom: '3px',
        fontWeight: '500 !important',
        color: `${theme.palette.grey[800]} !important`
    },
    labelFilledDisabled: {
        opacity: 0.55,
        cursor: 'not-allowed'
    },
    textFilled: {
        backgroundColor: '#F5F8FA !important',
        borderRadius: '0.625rem !important',
        '& input': {
            fontSize: '1.15rem !important',
            border: 'none !important',
            fontWeight: '500 !important',
            lineHeight: '1.5 !important',
            color: theme.palette.grey[700],
        },
    },
    menuItemSelect: {
        padding: '0.75rem 1.25rem !important',
        color: `${theme.palette.grey[700]} !important`,
        '&:hover': {
            color: `${theme.palette.success.main} !important`,
            backgroundColor: '#F4F6FA !important',
            fontWeight: 600
        },
        '&.Mui-selected': {
            color: `${theme.palette.success.main} !important`,
            backgroundColor: '#F4F6FA !important',
        },
        '&:hover.Mui-selected': {
            color: `${theme.palette.success.main} !important`,
            backgroundColor: '#F4F6FA !important'
        },
    }
});

export default controlledTextFieldStyles;